module.exports = __webpack_public_path__ + "static/media/up-arrow.8b6edbb1.svg";